export enum RemoteConfigIssue {
  None,
  Warning,
  Error,
}

export class RemoteConfigModel {
  public loadedConfig?: boolean = undefined
  public loadingConfig?: boolean = undefined
  public configError: RemoteConfigIssue = RemoteConfigIssue.None
  public enable_analytics_logging = false
  public show_cpg_tile = true // for hiding during demos
  public netSuiteOrgs: string[] = []
  public bmoIntegrationsWhitelist: string[] = []
  public pushToWalletWhitelist: string[] = []
  public expenseReviewWhitelist: string[] = []
  public enable_sso_login = false // Allows for SSO login and new login flow to be used
  public enable_sso_login_whitelist: string[] = [] // org IDs that have SSO login enabled
  public enable_mixpanel_analytics = true
  public show_bill_pay_history = false
  public show_new_budgets_table = false
  public show_bill_pay_share_later = false
  public show_new_filters_flyout = true
  public show_pnc_cobrand = false
  public bulk_select_fast_follows = false
  public show_brand_redirect = false
  public extendAIWhitelist: string[] = []
  public suggestionsAndPredictionsWhitelist: string[] = []
  public show_expense_policy_ai: boolean = false
  public show_expense_policy_ai_whitelist: string[] = []

  public show_ai_insights: boolean = false // enable AI Insights page
  public ai_insights_allowlist: string[] = [] // org IDs that have AI Insights enabled
  public show_extend_ai_agent: boolean = false // enable Extend AI Agent
  public show_suggestions_and_predictions: boolean = false // enable Suggestions and Predictions feature
  public show_sms_settings: boolean = false
  public show_enterprise_downgrade: boolean = false // enable enterprise downgrade flow
  public enable_starter_in_chargebee: boolean = false // enable starter flows backed by Chargebee (pricing + manage subscription)
  public show_saved_views: boolean = false
  public show_address_suggestions: boolean = false
  public enable_server_card_types: boolean = false // enable API-driven virtual card type picker
  public show_dynamic_pricing_page: boolean = false // enable API-driven pricing page
  public enable_unified_bill_pay_forms: boolean = false // enable unified BillPay forms using Standard content with isBillPay prop
  public enable_new_form_hooks: boolean = false // enable React Query hooks for virtual card forms
  public receipt_verification_ui_enabled: boolean = false // show receipt verification icons on transactions
  public enable_embedded_chargebee_checkout: boolean = false // enable Chargebee Embedded Checkout (inline iframe) instead of redirecting to hosted page
  public show_mileage_route_map: boolean = false
  public enable_partner_bank_astrada_onboarding: boolean = false // EX-39143 — gate partner bank Astrada onboarding flow (v2 ReviewEnrollCard path)
  public enable_low_balance_alert: boolean = false // EX-39237 — gate Low Balance Alert feature on VCN flyouts and detail page
  public enable_onboarding_resume_on_dropoff: boolean = false // EX-39432 — gate redirect from /home to /onboarding/card for admins/card-managers without a registered source card
  public enable_card_feeds: boolean = false // gate card feeds UI

  public chargebee_base_url = ''
  public chargebee_plan_id = ''
  public chargebee_coupon = ''
  public chargebee_start_timestamp = ''

  public static fromResponse(
    response: RemoteConfigResponse,
  ): RemoteConfigModel {
    const model = this.defaultConfig()
    Object.assign(model, response)
    return model
  }

  public static defaultConfig(): RemoteConfigModel {
    return { ...new RemoteConfigModel() }
  }
}

// any keys added above that should not show in the remote config UI should be added here
// TODO: string[] keys are already filtered out in `FeatureFlagger.tsx` since we don't have a way to modify them in the UI
enum RemoteConfigExclusions {
  loadedConfig,
  loadingConfig,
  configError,
}

export type RemoteConfigResponse = Omit<
  RemoteConfigModel,
  keyof RemoteConfigExclusions
>

export type RemoteConfigKeys = keyof RemoteConfigResponse
export const remoteConfigKeys: RemoteConfigKeys[] = Object.keys(
  RemoteConfigModel.defaultConfig(),
).filter((key) => !(key in RemoteConfigExclusions)) as RemoteConfigKeys[]
